
















import { Component, Vue } from 'vue-property-decorator';
import SubscriptionPlan from '../../components/SubscriptionPlan.vue';
import '../../assets/css/ServiceRequestDetails.scss';
@Component({
    components: {
        SubscriptionPlan,
    },
    props: {
        selectedPlan: String,
        excludePlan: String,
    },
})
export default class SetSubscriptionModal extends Vue {

    private show = true;
    private selectedSubscriptionPlan: string = '';

    private mounted() {
        this.selectedSubscriptionPlan = this.$props.selectedPlan;
    }

    private setPlan(selectedPlan: string) {
        this.selectedSubscriptionPlan = selectedPlan;
        this.$emit('select', this.selectedSubscriptionPlan);
    }

    private close() {
        this.$emit('close');
    }
}
